import { shipmentStatuses } from '@reveni-io/reveni-ui'

export const getPackableParcels = parcels => {
  return parcels?.filter(parcel => parcel.related && parcel.status !== shipmentStatuses.cancelled)
}
